import { UIEffects } from './dataBus.effects';

export const effects: any[] = [UIEffects];
